import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";
import IndustriesSection from '../../../components/IndustriesSection';
import { FaProjectDiagram, FaNetworkWired, FaCloud, FaCogs, FaChartLine, FaLightbulb, FaServer, FaLock } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/ssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";

const serviceCards = [
  {
    icon: <FaProjectDiagram size={80} color="var(--brand-primary)" />,
    title: "Technology Strategy & Roadmap",
    description: "Develop a clear technology vision and actionable roadmap. Align IT investments with your business goals for sustainable growth.",
  },
  {
    icon: <FaNetworkWired size={80} color="var(--brand-primary)" />,
    title: "IT Infrastructure Assessment",
    description: "Evaluate your current IT landscape for performance, security, and scalability. Identify gaps and opportunities for improvement.",
  },
  {
    icon: <FaCloud size={80} color="var(--brand-primary)" />,
    title: "Cloud Adoption & Migration",
    description: "Plan and execute seamless cloud migrations. Leverage cloud technologies for agility, cost savings, and innovation.",
  },
  {
    icon: <FaCogs size={80} color="var(--brand-primary)" />,
    title: "Systems Integration",
    description: "Integrate disparate systems and platforms for unified operations. Improve data flow and business process efficiency.",
  },
  {
    icon: <FaChartLine size={80} color="var(--brand-primary)" />,
    title: "Technology ROI Analysis",
    description: "Measure the value and impact of your technology investments. Make data-driven decisions for future IT initiatives.",
  },
  {
    icon: <FaLightbulb size={80} color="var(--brand-primary)" />,
    title: "Emerging Technology Advisory",
    description: "Stay ahead with guidance on AI, IoT, blockchain, and more. Identify the right innovations for your business.",
  },
  {
    icon: <FaServer size={80} color="var(--brand-primary)" />,
    title: "Architecture Design & Planning",
    description: "Design robust, scalable, and secure technology architectures. Ensure your IT foundation supports future growth.",
  },
  {
    icon: <FaLock size={80} color="var(--brand-primary)" />,
    title: "IT Risk & Security Assessment",
    description: "Identify and mitigate technology risks. Strengthen your security posture and ensure regulatory compliance.",
  },
];

const TechnologyConsultation = () => {
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" href={favIcon} />
        <title>Technology Consultation - Syrol Tech</title>
        <meta name="description" content="Expert technology consultation services. Get tailored solutions for your digital transformation and IT strategy." />
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="pages"
        secondParentMenu="others"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        CanvasLogo={Logo}
        mobileNormalLogo={Logo}
        CanvasClass="right_menu_togle hidden-md"
        headerClass="full-width-header header-style1 home8-style4"
        TopBar="enable"
        TopBarClass="topbar-area home8-topbar"
        emailAddress="hello@syroltech.com"
        Location="Abuja, Nigeria"
      />
      <SiteBreadcrumb
        pageTitle="Technology Consultation"
        pageName="Technology Consultation"
        breadcrumbsImg={bannerbg}
      />
      {/* Hero Section - Modern, full-width with background image and overlay */}
      <section className="consultation-hero-section position-relative w-100" style={{minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat`}}>
        <div className="hero-overlay" style={{position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1}}></div>
        <div className="container position-relative" style={{zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left'}}>
          <h1 style={{color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem'}}>Unlock the Potential of Technology for Your Business</h1>
          <p style={{color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem'}}>Transform your business with expert technology consultation. We provide actionable strategies, digital innovation, and IT solutions tailored to your unique needs.</p>
          <Link to="/consultation" className="readon orange-btn" style={{padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', background: '#111', color: '#fff'}}>Request A Free Proposal</Link>
        </div>
      </section>
      <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
        <div className="container pb-66 md-pb-46">
          <h2 className="service-title mb-32">Our Technology Consultation Services</h2>
          {serviceCards.map((card, idx) => (
            <ServiceCard
              key={idx}
              icon={card.icon}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </div>
      <IndustriesSection />
      <Newsletter
        sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
        titleClass="title mb-0 white-color"
      />
      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />
      <SearchModal />
      <ScrollToTop scrollClassName="scrollup orange-color" />
    </React.Fragment>
  );
};

export default TechnologyConsultation; 